































import { mapGetters } from 'vuex'
import Vue from 'vue'
export default Vue.extend ({
    props: {
        //  The person bound to the component
        person: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            overlay: false,
            provider: null
        }
    },
    mounted() {
        //  Determine if the person is a deleted Qbo or Xero contact
        const isQbo = this.qboCustomerDeleted(this.person)
        const isXero = this.xeroContactArchived(this.person)

        //  If a deleted contact exists, set the provider
        if (isQbo) this.provider = 'qbo'
        if (isXero) this.provider = 'xero'

        //  If the contact is deleted in Qbo OR Xero, show overlay
        if (isQbo || isXero) this.overlay = true
    },
    computed: {
        ...mapGetters(['qboCustomerDeleted', 'xeroContactArchived']),
        //  Check if the person is deleted in Qbo OR Xero
        providerDeleted(): boolean {
            if (this.qboCustomerDeleted(this.person)) return true
            if (this.xeroContactArchived(this.person)) return true
            return false
        },
        //  Returns the provider's readable name
        providerName(): string {
            if (this.provider === 'qbo') return 'QuickBooks Online'
            if (this.provider === 'xero') return 'Xero'
        },
        //  Returns the provider's entity name (ie Contact/Customer)
        providerType(): string {
            if (this.provider === 'qbo') return 'Customer'
            if (this.provider === 'xero') return 'Contact'
        }
    },
    methods: {
        goToProvider(): void {
            if (this.provider === 'qbo') return this.goToQboCustomer()
            if (this.provider === 'xero') return this.goToXeroContact()
        },
        goToQboCustomer(): void {
            //  Get the qbo id of the selected person
            const qboId = window.getProps(this.person, ['qbo_customer', 'qbo_id'])

            //  Get the base QuickBooks app url
            const base = process.env.VUE_APP_QBO_APP_URL

            //  Append the customer location to the base url
            const url = `${base}/app/customerdetail?nameId=${qboId}`

            //  Determine if we pop a new window
            const type = this.$store.getters.isApp ? '_system' : '_blank'

            //  Navigate user to QuickBooks Online customer
            window.open(url, type)
        },
        goToXeroContact(): void {
            //  Get the xero id
            const id = this.person.xero_contact.xero_id

            //  Determine if we pop a new window
            const type = this.$store.getters.isApp ? '_system' : '_blank'

            //  Navigate user to the Xero location
            window.open(`https://go.xero.com/Contacts/View/${id}`, type)
        },
        popProviderDeletedHelp(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: `Deleted in ${this.providerName}`,
                icon: 'mdi-help-circle',
                text: `This ${this.providerType} is deleted in ${this.providerName}.  It is recommended to restored the ${this.providerType} in ${this.providerName} before making changes here.`
            })
        }
    }
})
